import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=58d6ab6a&scoped=true&"
import script from "./pay.js?vue&type=script&lang=js&"
export * from "./pay.js?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=58d6ab6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6ab6a",
  null
  
)

export default component.exports